import paths from 'routing/routes/_paths';

import Indexes from 'views/indexes';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.indexes,
    component: Indexes,
    documentTitle: 'Indexes'
  }
];

export default routes;
